import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

const theme = extendTheme({
  // colors: {
  //   root: "#0f4f6d",
  //   blue: {
  //     1: '#2F6690',
  //     2: '#3A7CA5',
  //     3: '#16425B',
  //     4: '#81C3D7'
  //   },
  //   new: {
  //     grayHover: '#D9DCD6',
  //     grayBg: '#e9ecef'
  //   }
  // },
  styles: {
    global: {
      body: {
        fontFamily: 'Inter, sans-serif',
        background: '#f8f8fb',
      },
      'img, svg': {
        maxWidth: '100%',
      },
    },
  },
  // components: {
  //   Drawer: {
  //     variants: {
  //       permanent: {
  //         dialog: {
  //           pointerEvents: 'auto',
  //         },
  //         dialogContainer: {
  //           pointerEvents: 'none',
  //         },
  //       },
  //     },
  //   },
  // },
});

export function ThemeProvider({ children }: PropsWithChildren) {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
}